import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/login/login.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  isOTPSendSuccessfully = false;
  resetPasswordRequest = false;
  isOTPVariedSuccessfully = false;
  userId;
  OTP;
  newPassword;

  isLoaded = false;
  isSubmitted = false;
  userPostResData;
  isChangePasswordClicked = false;
  userValid;
  userLogin = false;
  forgetPassword = false;
  isLinkSendSuccessfully = true;
  invalid = false;
  constructor(private login_service: LoginService) { }

  ngOnInit() {
    this.init();
  }
  password_form: UntypedFormGroup;
  init() {
    this.password_form = new UntypedFormGroup(
      {
        login_id: new UntypedFormControl("", Validators.required),

      }
    );
  }

  onResetPassword(form) {
    this.isLoaded = true;
    this.userId = form.value.userId;

    if (this.userId == "") {

      this.invalid = true;


    }
    else {
      this.invalid = false;
    }
    if (!this.isOTPSendSuccessfully) {
      this.login_service.forgotPassword(this.userId).subscribe(resData => {

        if (resData['status'] == true) {
          this.isOTPSendSuccessfully = true;

          this.isLinkSendSuccessfully = false;
          this.isLoaded = false;
        }
        else {


        }

      },
        errorData => {

        }

      );
    }
    else {

    }
  }
  save() {
    if (this.password_form.value.login_id == "") {

      this.invalid = true;


    }
    else {
      this.invalid = false;



      this.login_service.forgotPassword(this.password_form.value.login_id).subscribe(resData => {

        if (resData['status'] == true) {
          this.isOTPSendSuccessfully = true;


        }
      });
    }
  }
}
